export default "__VITE_ASSET__BCx1X7FY__"